/**
 * The `.well-known` key MSC4143 advertises SFUs under. matrix-js-sdk models the
 * membership side of MSC4143 but not autodiscovery, so there is no SDK constant
 * to use here.
 */
export const RTC_FOCI_WELL_KNOWN_KEY = 'org.matrix.msc4143.rtc_foci';
export const getLivekitTransports = (discovery) => {
    const foci = discovery?.[RTC_FOCI_WELL_KNOWN_KEY];
    if (!Array.isArray(foci))
        return [];
    return foci.filter((focus) => typeof focus === 'object' &&
        focus !== null &&
        focus.type === 'livekit' &&
        typeof focus.livekit_service_url === 'string');
};
//# sourceMappingURL=rtcFoci.js.map